import { SlideMobileCommunityCardYoutubeStyled } from "./styled/SlideMobileCommunityCardsStyled";


export const YoutubeBanner = () => (
    <SlideMobileCommunityCardYoutubeStyled>
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7910_107759)">
                <circle cx="20.75" cy="20" r="20" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M28.8169 12.2467C30.9892 12.2467 32.75 13.7326 32.75 15.5659L32.7497 24.4664C32.7497 26.2993 30.9893 27.7856 28.8166 27.7856C21.5357 28.0716 19.8138 28.0713 12.6823 27.7856C10.5108 27.7856 8.75 26.2997 8.75 24.4664V15.5659C8.75 13.733 10.5105 12.2467 12.6823 12.2467C20.6975 11.9681 20.9533 11.871 28.8169 12.2467Z" fill="#EB3223" />
                <path d="M17.8242 16.9365V23.0944C17.8242 23.4517 18.249 23.6745 18.5874 23.4946L24.3816 20.4158C24.7179 20.2372 24.7179 19.7941 24.3817 19.6154L18.5875 16.5363C18.249 16.3564 17.8242 16.5792 17.8242 16.9365Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_7910_107759">
                    <rect width="40" height="40" fill="white" transform="translate(0.75)" />
                </clipPath>
            </defs>
        </svg>
        <div>Youtube</div>
    </SlideMobileCommunityCardYoutubeStyled>
);
